export const useStyles = () => {
    return {
        footer: {
            display: 'flex',
            justifyContent: 'end',
            width: '100%'
        },
        pagination: {
            '& .MuiPaginationItem-root': {
                margin: '10px 0 0 0',
            },
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width:'100%'
        },
        alignHorizontal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
        },
        wFull: {
            width: '100%'
        },
        paper: {
            padding:'10px',
            borderRadius:2,
            minHeight:'90%'
        },
        allButons: {
            display: 'flex',
            gap:'3px',
            alignItems: 'center'
        },
        cancelStyles: {
            width: {width: '430px'}
        },
         mainContainer: {
            display: 'flex',
            width: '100%',
            minHeight: '70vh',
            gap:1,
        },
        map: (expandMap:boolean) => ({
            width: '100%',
            minHeight: '100px',
            //display: 'flex',
            //justifyContent: 'end',
            overflow: 'hidden',
            transition: 'max-width 0.5s ease, opacity 0.5s ease',
            maxWidth: expandMap ? '55%' : 0,
            opacity: expandMap ? 1 : 0,
            visibility: expandMap ? 'visible' : 'hidden',
        }),
        containerUser: (expandMap:boolean) => ({
            width:expandMap ? '45%' : '100%'
        }),
        containerMap:{
            height:'93%'
        },
        seeButons: {
            textDecoration: 'underline',
            marginTop:'2px'
        },
        containerHidenButon:{
            display:'flex',
            justifyContent:'flex-end',
        }
    }
}